<template>
    <div class="container-fluid">
        <Breadcrumb title="Relay Reputation Providers" v-bind:button-show="false"></Breadcrumb>
        <div class="row" style="position: relative">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <div class="col-12" v-if="loading" style="min-height:100px;">
                            <Preloader v-bind:class="{preloader: loading}"></Preloader>
                        </div>
                        <div v-else>
                            <div v-if="providerList.length > 0">
                                <div class="table-responsive">
                                    <table class="table" id="providerTable">
                                        <thead>
                                        <tr>
                                            <th>ID</th>
                                            <th>Name</th>
                                            <th>Affects the relay status</th>
                                            <th>Active</th>
                                            <th>Actions</th>
                                        </tr>
                                        </thead>
                                        <tbody>
                                        <tr v-for="(provider, index) in providerList" :key="index">
                                            <td class="align-middle">{{provider.id}}</td>
                                            <td class="align-middle">{{provider.name}}</td>
                                            <td class="align-middle">
                                                <h4>
                                                    <span v-if="provider.affectsRelayStatus"
                                                          class="badge badge-pill badge-success">True</span>
                                                    <span v-if="!provider.affectsRelayStatus"
                                                          class="badge badge-pill badge-danger">False</span>
                                                </h4>
                                            </td>
                                            <td class="align-middle">
                                                <h4>
                                                    <span v-if="provider.active" class="badge badge-pill badge-success">True</span>
                                                    <span v-if="!provider.active" class="badge badge-pill badge-danger">False</span>
                                                </h4>
                                            </td>
                                            <td class="align-middle">
                                                <router-link
                                                        :to="{ name: 'ReputationProviderEdit', params: { id: provider.id }}"
                                                        class="btn btn-info btn-sm m-r-10">
                                                    <i class="fa fa-edit"></i> Edit
                                                </router-link>
                                            </td>
                                        </tr>
                                        </tbody>
                                    </table>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import ReputationProviderService from '../services/ReputationProviderService';
    import Preloader from '../components/Preloader';
    import Breadcrumb from '../components/Breadcrumb';

    export default {
        name: 'ReputationProviders',
        components: {
            Preloader,
            Breadcrumb
        },
        data() {
            return {
                providerList: [],
                loading: false,
            }
        },
        mounted() {
            this.getItems();
        },
        methods: {
            getItems: function () {
                this.loading = true;
                ReputationProviderService.getProviders().then(response => {
                    this.providerList = response.data['hydra:member'];
                    this.loading = false;
                });
            }
        }
    }
</script>

<style scoped>

</style>
